<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-toolbar>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" md="4">
            Devices
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
            <v-dialog v-model="dialog" max-width="850px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Add Tracker</v-btn>
              </template>
              <v-card>
                <v-card-text>
                 <v-form v-model="valid">
                  <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.name" label="Description" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.uniqueid" label="IMEI No" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.phone" label="Phone No" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.contact" label="Station" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.model" label="Platform No" required></v-text-field>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-form>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
      </v-card-title>
  <v-data-table
    :headers="headers"
    :items="devices"
    :search="search"
    :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="40"
    sort-by="calories"
    class="elevation-1"
  >
  <template v-slot:item.action="{ item }">
      <v-btn text icon color="blue" dark @click.native.stop="editItem(item)">
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      <v-btn text icon color="red" dark @click.native.stop="deleteItem(item)">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState, mapGetter, mapActions } from 'vuex'
export default {
  name: 'devices_on_pf',
  data () {
    return {
      valid: true,
      search: '',
      dialog: false,
      errors: [],
      headers: [
        {
          text: 'Device Id',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Description',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'IMEI No',
          align: 'left',
          sortable: true,
          value: 'uniqueid',
        },
        {
          text: 'Phone',
          align: 'left',
          sortable: true,
          value: 'phone',
        },
        {
          text: 'Station',
          align: 'left',
          sortable: true,
          value: 'contact',
        },
        { text: 'Platform No', value: 'model' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      train: {},
      train_loading: false,
      devices: [],
      editedIndex: -1,
      editedItem: {
        uniqueid:'',
        name:'',
        phone:'',
        contact:'',
        model: ''
      },
      defaultItem: {
        uniqueid:'',
        name:'',
        phone:'',
        contact:'',
        model: ''
      },
      }
  },
  computed: {
     formTitle () {
       return this.editedIndex === -1 ? 'Add Reader' : 'Edit Reader'
     },
   },

   watch: {
     dialog (val) {
       val || this.close()
     },
  },

   created () {
     this.initialize()
   },

  methods: {
    initialize() {
//      console.log(this.curDeviceId)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/device/get_devices_on_pf`)
      .then(response => {
        console.log(response);
        this.devices = []
        this.devices = response.data
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response.status === 401) {
          this.$router.push({
            name: 'Login'
          })
        }
      })
    },
    editItem (item) {
       this.editedIndex = this.devices.indexOf(item)
       this.editedItem = Object.assign({}, item)
       console.log(this.editedItem)
       this.dialog = true
     },

     deleteItem (item) {
       const index = this.devices.indexOf(item)
       var device = {
           id: item.id,
         }
       if (confirm('Are you sure you want to delete this item?')) {
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
         axios.delete(`${process.env.VUE_APP_API_URL}/device/delete_device_on_pf`, {params: device})
         .then(response => {
           //alert("Registered successfully")
            this.devices.splice(index, 1)
           })
         .catch(e => {
           console.log(e)
           this.errors.push(e)
         })
       }
     },

     close () {
       this.dialog = false
       setTimeout(() => {
         this.editedItem = Object.assign({}, this.defaultItem)
         this.editedIndex = -1
       }, 300)
     },
     save (item) {
       var device = {
         uniqueid:this.editedItem.uniqueid,
         name:this.editedItem.name,
         model:this.editedItem.model,
         contact:this.editedItem.contact,
         phone:this.editedItem.phone
       }
       if (this.editedIndex > -1) {
         device.id = this.editedItem.id
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
         axios.put(`${process.env.VUE_APP_API_URL}/device/update_device_on_pf`, device)
         .then(response => {
           this.initialize()
           })
         .catch(e => {
           console.log(e)
           this.errors.push(e)
         })

       } else {
         //console.log(train_device_map)
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
         axios.post(`${process.env.VUE_APP_API_URL}/device/add_device_on_pf`, device)
         .then(response => {
          this.initialize()
          //alert("Registered successfully")
           })
         .catch(e => {
           console.log(e)
           this.errors.push(e)
         })

       }
       this.close()
     },
    }
}
</script>
